import styled from 'styled-components'
import { tabletBreakpoint, mobileBreakpoint, desktopBreakpoint } from 'react-components'

export const HeroSectionContainer = styled.section`
    margin-top: 3.75rem;
    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        margin-top: 4.75rem;
    }
`

export const BackgroundShadowContainer = styled.div`
    display: ${props => props.theme.style.display.flex};
    flex-direction: ${props => props.theme.style.flexDirection.column};
    background-image: linear-gradient(
        to bottom,
        ${props => props.theme.colors.tfwBlack87}00 33%,
        ${props => props.theme.colors.tfwBlack87}d9 61%
    );

    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        padding: 0 1.25rem;
    }
    @media only screen and (min-width: ${desktopBreakpoint.min}px) {
        background-image: linear-gradient(to right, rgba(0, 0, 0, 0) 50%, rgba(0, 0, 0, 0.3) 100%),
            linear-gradient(
                to bottom,
                ${props => props.theme.colors.tfwBlack87}00 50%,
                ${props => props.theme.colors.tfwBlack87}80 65%
            );
    }
`

export const BackgroundChildContainer = styled.div`
    display: ${props => props.theme.style.display.flex};
    flex-direction: ${props => props.theme.style.flexDirection.column};
    padding: 0 0.625rem;
    box-sizing: border-box;
    @media only screen and (min-width: 432px) and (max-width: ${mobileBreakpoint.max}px) {
        align-items: ${props => props.theme.style.alignItems.center};
    }
    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        padding: 0 1.25rem;
    }
    @media only screen and (min-width: ${desktopBreakpoint.min}px) {
        padding: 5.125rem 0 3.125rem;
        width: ${({ theme }) => theme.layout.fill};
        flex-direction: ${props => props.theme.style.flexDirection.row};
        align-items: ${props => props.theme.style.alignItems.flexEnd};
        max-width: 1110px;
        margin: 0 auto;
        justify-content: ${props => props.theme.style.justifyContent.spaceBetween};
    }
`

export const TitleContainer = styled.h1`
    margin: ${props => props.theme.spacing.medium} 0;
    align-self: ${props => props.theme.style.alignSelf.center};
    text-shadow: 0 ${props => props.theme.spacing.xxxSmall} ${props => props.theme.spacing.xxSmall} rgba(0, 0, 0, 0.5);
    font-family: ${props => props.theme.typography.font.family.yummo};
    font-size: ${props => props.theme.typography.font.size.xxLarge};
    line-height: 1.13;
    text-align: ${props => props.theme.style.textAlign.center};
    color: ${props => props.theme.colors.white};
    max-width: 29rem;
    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        margin-top: 1.875rem;
        font-weight: bold;
        line-height: 1;
        font-size: 3.5rem;
        max-width: 51rem;
    }

    @media only screen and (min-width: ${desktopBreakpoint.min}px) {
        align-self: ${props => props.theme.style.alignSelf.flexEnd};
        margin-bottom: 5.1875rem;
        text-align: ${props => props.theme.style.textAlign.left};
        font-weight: bold;
        line-height: 1;
        font-size: 3.48rem;
        max-width: 30.625rem;
    }
    @media only screen and (min-width: 1110px) {
        font-size: 3.5rem;
        max-width: 32.375rem;
    }
`

export const TrustBarContainer = styled.div`
    display: ${props => props.theme.style.display.flex};
    flex-direction: ${props => props.theme.style.flexDirection.row};
    justify-content: ${props => props.theme.style.justifyContent.spaceBetween};
    margin-top: 2.8125rem;
    @media only screen and (min-width: 26rem) and (max-width: ${mobileBreakpoint.max}px) {
        min-width: 26rem;
    }
    @media only screen and (min-width: ${tabletBreakpoint.min}px) and (max-width: ${tabletBreakpoint.max}px) {
        margin: 7.5625rem auto 0;
        min-width: 32rem;
    }
    @media only screen and (min-width: ${desktopBreakpoint.min}px) {
        margin: 0;
        width: 30.75rem;
        height: fit-content;
    }
`

export const ButtonContainer = styled.div`
    display: ${props => props.theme.style.display.flex};
    flex-direction: ${props => props.theme.style.flexDirection.column};
    margin-top: 1.25rem;
    color: ${props => props.theme.colors.tfwBlack87};
    @media only screen and (min-width: 432px) and (max-width: ${mobileBreakpoint.max}px) {
        min-width: 26rem;
        margin-left: auto;
        margin-right: auto;
    }
    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        margin: 1.25rem auto 0;
    }
    @media only screen and (min-width: ${desktopBreakpoint.min}px) {
        margin: 0;
    }
`

export const ButtonContentContainer = styled.div`
    padding: ${props => props.theme.spacing.medium} 2.375rem 1.0625rem;
    font-family: ${props => props.theme.typography.font.family.lato};
    text-align: ${props => props.theme.style.textAlign.center};
    font-weight: bold;
    font-size: 1.375rem;
    line-height: normal;
    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        padding: 1.3125rem 7.3125rem 1.5625rem;
        font-size: 1.75rem;
    }
    @media only screen and (min-width: ${desktopBreakpoint.min}px) and (max-width: 1110px) {
        font-size: 1.72rem;
        padding: 1.3125rem 6.6rem 1.5625rem;
    }
    @media only screen and (min-width: 1111px) {
        padding: 1.3125rem 7.3rem 1.5625rem;
    }
`

export const Subtitle = styled.div`
    margin: 0.625rem auto 1.25rem;
    font-family: ${props => props.theme.typography.font.family.lato};
    font-size: 0.9375rem;
    opacity: 0.8;
    font-style: italic;
    max-width: 18.75rem;
    line-height: normal;
    text-align: ${props => props.theme.style.textAlign.center};
    color: ${props => props.theme.colors.white};
    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        margin: 0.9375rem auto 1.875rem;
        font-size: 0.9375rem;
        max-width: 22rem;
    }
    @media only screen and (min-width: ${desktopBreakpoint.min}px) {
        margin: 0.9375rem auto 0;
        font-size: 0.9375rem;
        max-width: 22rem;
    }
`

export const LogoutButton = styled.a`
    font-style: normal;
    font-size: ${({ theme }) => theme.typography.font.size.medium};
    &:link,
    &:visited,
    &:active {
        color: ${props => props.theme.colors.white};
    }
`

export const Container = styled.div`
    margin: auto;
    @media only screen and (min-width: ${desktopBreakpoint.min}px) {
        margin: 0px;
    }
`
